// removed by extract-text-webpack-plugin
module.exports = {"button-container":"invite-user-modal__button-container___3zB1f","cancel":"invite-user-modal__cancel___375tX"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/settings/invite-user-modal.scss
// module id = 1360
// module chunks = 0